var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 701,
    height: 693,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 334.964V613h541V334.846L351.898 93.603 80 334.963zM13.446 287.07l312.03-276.985c15.204-13.498 38.115-13.441 53.254.13L687.7 287.201a40 40 0 0 1 13.3 29.784V653c0 22.091-17.909 40-40 40H40c-22.091 0-40-17.909-40-40V316.985a40 40 0 0 1 13.446-29.914z"
  })));
};

export default SvgHouse;